<template>

	<div class="page-main">
		<div class="page-head">
			<nav-bar title="优惠券" :border="false" :left-arrow="true" @click-left="pageBack"></nav-bar>
		</div>
		<div class="coupons-list">
			<div class="coupons-item" v-for="item in couponsList" :key='item.id' @click="showDialog(item)">
				<div class="title">{{item.title}}</div>
				<div class="tiem">有效期至:{{item.expiredDate}}</div>
				<!-- <div class="btn" @click="clickCoupons(item)">兑换</div> -->
			</div>

		</div>
	</div>


</template>

<script>
	import {
		getRewards
	} from "@/api";
	import {
		navBar,
		Dialog
	} from "vant";


	export default {
		data() {
			return {
				couponsList: []
			};
		},

		async mounted() {
			var header = window.__xr_bmobdb && window.__xr_bmobdb();


			const res = await getRewards(header);

			if (res.code === 0) {
				this.couponsList = res.data
			}
		},

		methods: {
			// clickCoupons(d){
			//   this.isShow = false;
			//   this.$emit('clickCoupons',d['coupons']);
			// },
			showDialog(item) {
				// this.show = true
				// this.couponInfo = item
				Dialog.alert({
					title: item.title,
					message: item.usageDescription,
				})
			},
			show() {
				this.isShow = true
			},
			pageBack() {
				window.history.back();
			},
		},
		computed: {
			money() {
				var num = Number(this.spec.price) || 0;
				for (var item of this.formData) {
					num += Number(item.price) || 0;
				}
				return num * this.number / 100;
			},
			specList() {
				this.coffeeSku.map((d) => {
					d.id = d["spec_id"];
				});
				return {
					name: "杯型",
					extra_list: this.coffeeSku
				};
			},
		},
		components: {
			navBar
		},
	};
</script>

<style lang="scss" scoped>
	.coupons-item {
		margin: 30px;
		padding: 30px 20px;
		border-radius: 16px;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
		position: relative;

		.btn {
			position: absolute;
			right: 40px;
			top: 50%;
			margin-top: -30px;
			width: 150px;
			height: 60px;
			line-height: 60px;
			text-align: center;
			background: #00af66;
			color: #fff;
			border-radius: 30px;
			letter-spacing: 2px;
		}

		.title {
			font-size: 30px;
			font-weight: bold;
			margin-bottom: 20px;
		}

		.tiem {
			color: #666;
			font-size: 24px;
		}
	}
</style>